import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

import {SidenavComponent} from "./sidenav.component";
import {RouterModule} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";
import {HomescreenModule} from "../../feature/homescreen/homescreen.module";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import {MatDividerModule} from "@angular/material/divider";
import {MepPopoverModule} from "../mep-popover/mep-popover.module";

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		RouterModule,
		MatIconModule,
		HomescreenModule,
		MatSidenavModule,
		MatTooltipModule,
		MatButtonModule,
		MatDividerModule,
		MepPopoverModule,
		SidenavComponent,
	],
	exports: [SidenavComponent],
})
export class SidenavModule {}
